// ページ読み込み時の初期化
document.addEventListener("DOMContentLoaded", () => {
  console.log("Hero section loaded");
});
